import { INTERVALS } from '../../utils/constants';

function IntervalButtons({ selectedInterval, onIntervalChange, customRange, onCustomRangeChange }) {
    const intervals = [
        { key: INTERVALS.TODAY, label: 'Today' },
        { key: INTERVALS.YESTERDAY, label: 'Yesterday' },
        { key: INTERVALS.WEEK, label: 'Last Week' },
        { key: INTERVALS.MONTH, label: 'Last Month' }
    ];

    const safeRange = customRange || { start: '', end: '' };

    const handleRangeInput = (field) => (event) => {
        const value = event.target.value;
        const nextRange = {
            ...safeRange,
            [field]: value,
        };
        onCustomRangeChange?.(nextRange);
    };

    const handleClearRange = () => {
        onCustomRangeChange?.({ start: '', end: '' });
        onIntervalChange?.(INTERVALS.TODAY);
    };

    return (
        <div className="interval-controls">
            <div className="interval-buttons">
                {intervals.map(({ key, label }) => {
                    const isActive = selectedInterval === key;
                    return (
                        <button
                            key={key}
                            type="button"
                            onClick={() => {
                                onIntervalChange(key);
                            }}
                            className={isActive ? 'is-active' : ''}
                        >
                            {label}
                        </button>
                    );
                })}
            </div>
            <div className={`interval-range ${selectedInterval === INTERVALS.CUSTOM ? 'is-active' : ''}`}>
                <span>Custom range</span>
                <div className="interval-range__inputs">
                    <input type="date" value={safeRange.start} onChange={handleRangeInput('start')} />
                    <span className="interval-range__separator">to</span>
                    <input type="date" value={safeRange.end} onChange={handleRangeInput('end')} />
                    {(safeRange.start || safeRange.end) && (
                        <button type="button" className="interval-range__clear" onClick={handleClearRange}>
                            Clear
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default IntervalButtons;
